import { FC, ReactNode } from "react";

import { Heading, HStack, Text, VStack } from "./base";

interface HeaderProps {
  right?: ReactNode;
  subtitle?: string;
  title: string;
}

const Header: FC<HeaderProps> = ({ subtitle, title, right }) => {
  return (
    <HStack className="justify-between w-full px-8 pt-8 pb-6">
      <VStack className="space-y-2">
        <Heading className="text-3xl font-bold text-typography-900 dark:text-typography-50">
          {title}
        </Heading>
        {subtitle && (
          <Text className="text-md text-typography-600 dark:text-typography-400">
            {subtitle}
          </Text>
        )}
      </VStack>
      {right}
    </HStack>
  );
};

export default Header;
